import React, { useRef, useEffect } from "react";
import ReactHtmlParser from "react-html-parser";
import { useState } from "./hooks/useState";
import useCMS from "./hooks/useCMS";

function SuccessPage() {
  const cmsData = useCMS();
  const { successType } = useState();
  const contentRef = useRef();
	
  useEffect(() => {
    contentRef.current.scrollIntoView(false);
  }, [contentRef]);

  return (
    <div ref={contentRef} className="content">
      <div className="info-box">
        <h3>{cmsData[successType].headline}</h3>
        {cmsData[successType].information && (
          <p>{ReactHtmlParser(cmsData[successType].information)}</p>
        )}
      </div>
    </div>
  );
}

export default SuccessPage;
